import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';

import { AuthRepository } from './auth.repository';
import * as moment from 'moment';
import jwt_decode from 'jwt-decode';
import { User } from './login/dto/user.entity';
import { HttpClient } from '@angular/common/http';
import { SynchronizationService } from 'app/shared/synchronization.service';
import { NbGlobalPhysicalPosition, NbToastrService } from '@nebular/theme';
import { environment } from 'environments/environment';
import { SiteSettings } from 'app/pages/settings/settings-page/site-settings';
import { ConfigurationService } from 'app/services/configurations/configurations.service';
import { Configuration } from 'app/models/configuration/configuration';
import { AppConfigService } from 'app/services/app-config/app-config.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {

  url: string;
  cnpj: string;
  accessToken: string;
  user: User;
  siteSettings = SiteSettings.getInstance();

  constructor(
    private authRepository: AuthRepository,
    private synchronizationService: SynchronizationService,
    private httpClient: HttpClient,
    private toastrService: NbToastrService,
    private appConfigService: AppConfigService
  ) {

  }

  getAccessToken(id, password) {
    return new Promise((resolve, reject) => {
      this.authRepository.getToken(id, password, this.appConfigService.apiBaseUrl).subscribe((data: any) => {
        if (data) {
          this.setSession(data.access_token);
          localStorage.setItem('accessToken', JSON.stringify(data.access_token));
          var tokenData: any = jwt_decode(data.access_token);

          sessionStorage.setItem('showListPrice', tokenData['showListPrice'] ?? false);

          if (tokenData['paymentCondition'] != null) {
            sessionStorage.setItem('selectedReceivingConditionId', tokenData['paymentCondition']);
            sessionStorage.setItem('defaultReceivingConditionId', tokenData['paymentCondition']);
          }

          if (tokenData['paymentMethod'] != null)
            sessionStorage.setItem('selectedPaymentReceiptFormId', tokenData['paymentMethod']);

          sessionStorage.setItem('defaultCategories', tokenData['defaultCategories'] ?? '');
          resolve(data);
        }
        reject();
      });
    })
      .then(() => {
        this.synchronizationService.startSynchronize(this.cnpj);
      })
      .catch(err => {
        this.toastrService.show('Valide os dados e tente novamente!', 'Falha ao realizar Login',
          { status: 'danger', position: NbGlobalPhysicalPosition.BOTTOM_RIGHT, duration: 10000 });
      });
  }

  setSession(authResult) {
    const decode: User = jwt_decode(authResult);
    this.getCompleteUser(decode, authResult);
    const expiresAt = decode.exp;
    sessionStorage.setItem('expires_at', JSON.stringify(expiresAt));
  }

  async getCompleteUser(loginUser: User, bearer: string) {
  }

  getUser() {
    // TODO - Buscar dado correto do usuário
    return {
      name: "J BRESSAN PRODUTOS NATURAIS LTDA",
      id: 5,
      branchCode: 1,
      iat: 1651602415,
      exp: 1651688815
    };
  }

  public isLoggedIn() {
    return moment().isBefore(this.getExpiration());
  }

  isLoggedOut() {
    return !this.isLoggedIn();
  }

  getExpiration() {
    const expiration = JSON.parse(sessionStorage.getItem('expires_at'));
    const expiresAt = expiration * 1000;
    return moment(expiresAt);
  }

  getShowConditionAndForm() {
    var temp = localStorage.getItem('accessToken');

    if (temp != null) {
      temp = jwt_decode(temp);

      return ((temp['recAndPayForm'] ?? false));
    }

    return false;
  }

  isAdmin() {
    var temp = localStorage.getItem('accessToken');

    if (temp != null) {
      temp = jwt_decode(temp);

      return ((temp['administrator'] === 'S' ?? false));
    }

    return false;
  }

  static extractTokenInfo(propertyName: string) {
    const token = localStorage.getItem('accessToken');

    if (!token) return null;
    return jwt_decode(token)[propertyName];
  }

  passwordRecovery(userId: string) {
    return this.authRepository.passwordRecovery(userId, this.appConfigService.apiBaseUrl)
  }
}
